<template>
  <scroll-layout class="details">
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <template v-for="(button, index) in pageButtons">
          <ykc-button
            :key="index"
            v-if="button.enabled"
            v-bind="button"
            @click="button.handleClick(button, $event)">
            {{ button.text }}
          </ykc-button>
        </template>
      </div>
    </template>
    <div class="content">
      <ykc-detail-plus class="box-card" :labelWidth="70">
        <div slot="header" class="clearfix" style="height: auto">
          <div class="btn-wrap">
            <el-button
              size="small"
              class="confirm"
              :loading="loading"
              type="primary"
              @click="submit">
              提交申请
            </el-button>
          </div>

          <span>基本信息</span>
        </div>
        <div class="flexBox">
          <ykc-form
            ref="ruleForm"
            class="YkcForms"
            :model="ruleForm"
            :rules="rules"
            labelPosition="right">
            <ykc-form-item
              label="结算时间"
              prop="settleDate"
              style="width: 380px; margin-bottom: 0">
              <el-date-picker
                v-model="ruleForm.settleDate"
                type="monthrange"
                range-separator="至"
                @change="timeChange"
                start-placeholder="结算开始月份"
                end-placeholder="结算结束月份"
                :picker-options="pickerOptions"
                format="yyyy-MM"
                value-format="yyyy-MM"></el-date-picker>
            </ykc-form-item>
          </ykc-form>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="结算方式">
            <span>{{ settleWayName(formData.settleWayName || formData.settleWay) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="站点编码">
            <span>{{ dealData(formData.stationCode) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="站点名称">
            <span>{{ dealData(formData.stationName) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="经营模式">
            <span>{{ tradeModeName(formData.tradeModeName || formData.tradeMode) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="商户">
            <span>{{ dealData(formData.operatorName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="取电方式">
            <span>{{ eleWayName(formData.eleWayName || formData.eleWay) }}</span>
          </ykc-detail-item-plus>
        </div>

        <div class="flexBox">
          <ykc-detail-item-plus label="总电量">
            <span>
              {{ dealData(formData.settleTotalEleCap) }}
            </span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="电费">
            <span>{{ dealData(formData.settleTotalPowerFee) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="服务费平台抽成">
            <span>{{ dealData(formData.serviceWayFeeStr) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="用户实付金额">
            <span>{{ dealData(formData.userActualIncome) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="用户退款金额">
            <span>{{ dealData(formData.userRefundAmount) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="服务费平台分成">
            <span>{{ dealData(formData.serviceSharingFee) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="退款后平台分成返还">
            <span>{{ dealData(formData.platformSharingReturn) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="结算总金额">
            <span>{{ dealData(formData.settleTotalAmount) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="备注">
            <ykc-input
              v-model="ruleForm.remark"
              type="textarea"
              placeholder="备注"
              maxlength="500"></ykc-input>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label=""></ykc-detail-item-plus>
        </div>
        <ykc-table
          ref="YkcTable"
          style="box-shadow: none"
          operateFixedType="right"
          :data="tableData"
          title="结算清单按月信息"
          :columns="tableColumns"
          :operateButtons="tableOperateButtons"></ykc-table>
      </ykc-detail-plus>
    </div>
  </scroll-layout>
</template>

<script>
  import dayjs from 'dayjs';
  import { franchiseeSettleManage } from '@/service/apis';
  import { offlineExport } from '@/utils';
  // import { dealData } from '@/utils/index';

  export default {
    name: 'settle',
    components: {},
    data() {
      return {
        stationId: '',
        formData: {},
        loading: false,
        ruleForm: {
          remark: '',
          startTime: '',
          endTime: '',
          settleDate: [],
          // settleDate: [null, '2024-06'],
        },
        // 可结算月份置灰控制
        settleableMonths: [],
        monthStatusLoaded: false,
        pickerOptions: {
          disabledDate: date => {
            if (!date) {
              return false;
            }
            // ===== 上线解开-begin：当月不可结算（测试期当月可结，上线时解开以下三行） =====
            // if (dayjs(date).startOf('month').valueOf() >= dayjs().startOf('month').valueOf()) {
            //   return true;
            // }
            // ===== 上线解开-end：当月不可结算 =====
            // 状态未加载前先禁未来月
            const month = dayjs(date).format('YYYY-MM');
            if (!this.monthStatusLoaded) {
              return dayjs(date).startOf('month').valueOf() > dayjs().startOf('month').valueOf();
            }
            return !this.settleableMonths.includes(month);
          },
        },
        rules: {
          settleDate: [
            { type: 'array', required: true, message: '请选择结算日期', trigger: 'blur' },
          ],
        },
        tableData: [],
        tableColumns: [
          {
            label: '年月',
            prop: 'date',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                return dayjs(row.date).format('YYYY-MM');
              },
            },
          },
          { label: '电量', prop: 'eleCap', minWidth: '100px' },
          { label: '电费', prop: 'eleFee', minWidth: '100px' },
          { label: '用户实付金额', prop: 'userActualIncome', minWidth: '110px' },
          { label: '用户退款金额', prop: 'userRefundAmount', minWidth: '110px' },
          { label: '服务费平台分成', prop: 'serviceFeeSharingAmount', minWidth: '120px' },
          { label: '退款后平台分成返还', prop: 'platformSharingReturn', minWidth: '130px' },
          { label: '结算金额', prop: 'totalAmount', minWidth: '100px' },
        ],
        tableOperateButtons: [
          {
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.exportDetail(row);
                }}>
                导出订单明细
              </ykc-button>
            ),
          },
        ],
      };
    },
    computed: {
      pageButtons() {
        return [
          {
            text: '返回',
            type: 'plain',
            enabled: true,
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ];
      },
    },
    created() {
      const { stationId } = this.$route.query;

      this.stationId = stationId;
      this.queryMonthStatus();
    },
    methods: {
      /**
       * 初始数据
       */

      initData() {
        this.tableOperateButtons = [];
      },

      // 可结算月份集合
      queryMonthStatus() {
        if (!this.stationId) {
          return;
        }
        franchiseeSettleManage
          .getMonthStatus({
            stationId: this.stationId,
            // 统计到当月末，当月可结；上线配合解开当月禁用注释
            endTime: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
          })
          .then(res => {
            this.settleableMonths = (res || [])
              .filter(item => item.settleable)
              .map(item => item.month);
            this.monthStatusLoaded = true;
          })
          .catch(() => {});
      },

      dealData(value) {
        return value === null || value === undefined || value === '' ? '——' : value;
      },

      tradeModeName(value) {
        if (value === 1) {
          return '自营';
        }
        if (value === 2) {
          return '加盟商';
        }
        return this.dealData(value);
      },

      settleWayName(value) {
        if (value === 1) {
          return '按系统结算';
        }
        return this.dealData(value);
      },

      eleWayName(value) {
        if (value === 1) {
          return '加盟商取电';
        }
        return this.dealData(value);
      },

      queryDetail() {
        // 编辑回显
        if (this.stationId) {
          franchiseeSettleManage
            .getSettleInfo({
              stationId: this.stationId,
              startTime: this.ruleForm.startTime,
              endTime: this.ruleForm.endTime,
            })
            .then(res => {
              this.formData = res || {};

              this.tableData = this.formData.settleDetail || [];
            })
            .catch(() => {});
        }
      },
      timeChange(value) {
        if (!value || value.length < 2) {
          this.ruleForm.startTime = '';
          this.ruleForm.endTime = '';
          this.tableData = [];
          return;
        }
        this.ruleForm.startTime = dayjs(value[0]).startOf('month').format('YYYY-MM-DD HH:mm:ss');
        this.ruleForm.endTime = dayjs(value[1]).endOf('month').format('YYYY-MM-DD HH:mm:ss');

        this.queryDetail();
      },
      /**
       * @desc 导出明细
       * */
      exportDetail(row) {
        const { date } = row;
        const { stationId } = this;
        offlineExport({
          downloadType: 'finance_export',
          jsonNode: {
            downloadKey: 'franchiseeSettleExportMonthDetail',
            stationId,
            settleStartTime: dayjs(date).startOf('month').format('YYYY-MM-DD'),
            settleEndTime: dayjs(date).endOf('month').format('YYYY-MM-DD'),
          },
        });
      },
      submit() {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.loading = true;
            franchiseeSettleManage
              .addOne({
                endSettleDate: this.ruleForm.endTime,
                stationId: this.stationId,
                remark: this.ruleForm.remark,
                serviceWayFeeStr: this.formData.serviceWayFeeStr,
                startSettleDate: this.ruleForm.startTime,
              })
              .then(() => {
                this.loading = false;
                this.$router.go(-1);
              })
              .catch(() => {
                this.loading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    .box-card {
      width: 100%;
      height: auto;
      border-radius: 0;
      margin: 10px 0px 0px 0px;
      border: none;
      .btn-wrap {
        margin-bottom: 10px;
      }
      ::v-deep .el-card__header {
        border: 0;
        padding: 10px;
        height: auto;
        box-sizing: border-box;

        @media screen and (max-width: 1366px) {
          height: auto;
        }
      }
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .flexBox {
        display: flex;
        margin-bottom: 20px;
      }
      .YkcForms {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        ::v-deep .ykc-form-item {
          width: 50%;
          .el-form-item {
            display: flex;

            .el-form-item__label {
              line-height: 30px;
              padding: 0 8px 0 0;
              font-size: 12px;
              width: 74px;
            }

            .el-form-item__content {
              flex: 1;
            }
          }
        }
      }
    }
  }
</style>
